namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeDiscRoundMethod {
        DiscRoundMethod = 0,
        DiscRoundMethod1 = 1,
        DiscRoundMethod2 = 2,
        DiscRoundMethod3 = 3,
        DiscRoundMethod4 = 4,
        DiscRoundMethod5 = 5,
        DiscRoundMethod6 = 6
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeDiscRoundMethod, 'GeniuzPOS.Administration.PsParaGenTypeDiscRoundMethod', 'Administration.PsParaGenTypeDiscRoundMethod');
}
